import type { CacheJS } from 'eplayer-core'
import type { PlayerCache } from 'eplayer-core'
import { Media } from 'eplayer-core'

import type { AssetManagerEntry } from '@common/media'

export async function cacheMediaInfo(cache: PlayerCache, mediaInfo: AssetManagerEntry) {
  const filename = mediaInfo.fileName
  let media: Media.Media
  try {
    switch(mediaInfo.fileExt) {
      case 'jpeg': case 'jpg': case 'svg': case 'png':
        media = Media.RawSprite.withDefaults(mediaInfo)
        break
      case 'mp4':
        media = Media.RawVideo.withDefaults(mediaInfo)
        break
      case 'mp3':
        media = Media.RawAudio.withDefaults(mediaInfo)
        break
      case 'html': case 'js':
        media = Media.RawHTML.withDefaults(mediaInfo)
        break
      default:
        throw new Error(`Encountered unknown asset manager response type: ${JSON.stringify(mediaInfo)}`)
    }
  } catch(err) {
    const msg = err instanceof Error ?
      `Failed to create media object for ${filename}: ${(err as Error).message}` :
      `Failed to create media object for ${filename}: ${String(err)}`
    throw new Error(msg)
  }
  cache.addResource(media)
  const [ resource, ] = await cache.load(media.src)
  if (media.fileExt === 'js') {
    const rawHTML = media as Media.RawHTML
    const cache = resource as CacheJS
    rawHTML.labels = cache.source.labels
    rawHTML.totalFrames = cache.source.totalFrames
    rawHTML.animationHeight = cache.source.height
    rawHTML.animationWidth = cache.source.width
  }
  return media
}
